import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    messages: [],
    totalCount: 0,
  },
  actions,
  getters,
  mutations,
};
